(() => {
  const container = document.querySelector('#ProductGridContainer');
  const grid = document.querySelector('#product-grid');
  if (!container || !grid) return;

  const log = (...args) => console.log('[Infinite]', ...args);

  let loading = false;
  let done = false;

  // Track product links already on the page (dedupe)
  const seen = new Set(
    Array.from(grid.querySelectorAll('a[href*="/products/"]'))
      .map((a) => a.getAttribute('href'))
      .filter(Boolean)
  );

  // Start from current URL page (default 1)
  const urlNow = new URL(window.location.href);
  let nextPage = parseInt(urlNow.searchParams.get('page') || '1', 10) + 1;

  function baseUrl() {
    const u = new URL(window.location.href);
    u.searchParams.delete('page');
    return u;
  }

  function pageUrl(pageNum) {
    const u = baseUrl();
    u.searchParams.set('page', String(pageNum));
    return u.toString();
  }

  function ensureLoader() {
    let l = container.querySelector('[data-infinite-loader]');
    if (!l) {
      l = document.createElement('div');
      l.setAttribute('data-infinite-loader', 'true');
      l.style.textAlign = 'center';
      l.style.padding = '16px';
      l.style.display = 'none';
      l.textContent = 'Loading more...';
      container.appendChild(l);
    }
    return l;
  }

  function lastItem() {
    const items = grid.querySelectorAll('li.grid__item');
    return items.length ? items[items.length - 1] : null;
  }

  let io = null;

  async function loadNext() {
    if (loading || done) return;

    loading = true;
    const loader = ensureLoader();
    loader.style.display = 'block';

    const targetUrl = pageUrl(nextPage);
    log('Loading page', nextPage, targetUrl);

    try {
      const res = await fetch(targetUrl, { credentials: 'same-origin' });
      log('Fetch status:', res.status, 'Final URL:', res.url);

      if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);

      // If Shopify redirects out-of-range pages back to page=1, stop.
      const final = new URL(res.url);
      const finalPage = parseInt(final.searchParams.get('page') || '1', 10);
      if (finalPage === 1 && nextPage !== 1) {
        done = true;
        log('Redirected back to page=1 -> done.');
        return;
      }

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('#product-grid');
      if (!newGrid) throw new Error('No #product-grid found on fetched page');

      const newItems = Array.from(newGrid.querySelectorAll('li.grid__item'));

      const newLinks = Array.from(newGrid.querySelectorAll('a[href*="/products/"]'))
        .map((a) => a.getAttribute('href'))
        .filter(Boolean);

      const freshLinks = newLinks.filter((href) => !seen.has(href));
      log('Fetched items:', newItems.length, 'Fresh products:', freshLinks.length);

      if (!newItems.length || freshLinks.length === 0) {
        done = true;
        log('No new products detected -> done.');
        return;
      }

      newItems.forEach((li) => grid.appendChild(li));
      freshLinks.forEach((href) => seen.add(href));

      nextPage += 1;
      resetObserver();
    } catch (e) {
      console.error('[Infinite] Error:', e);
      done = true;
    } finally {
      loader.style.display = 'none';
      loading = false;
    }
  }

  function resetObserver() {
    if (io) io.disconnect();

    const target = lastItem();
    if (!target) return;

    io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          log('Bottom reached -> loadNext()');
          loadNext();
        }
      },
      { rootMargin: '900px 0px' }
    );

    io.observe(target);
    log('Watching last item. Next page:', nextPage);
  }

  resetObserver();
})();
